import cookie from 'react-cookies';

import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/constants';

const getAccessToken = (): string => {
    return cookie.load(ACCESS_TOKEN_COOKIE) || '';
};

export default getAccessToken;
